// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3f9ES","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3mcWc","obliqueLine":"membershipbadge_obliqueLine__3jeI5"};